// extracted by mini-css-extract-plugin
module.exports = {"delete":"TransactionParticipantForm_delete_3r7J-"};